import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';

import AutoComplete from 'material-ui/AutoComplete';
import { List, ListItem } from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import ClearIcon from 'material-ui/svg-icons/content/clear';
// color
import { colors } from '../../lib/styles';

class ArticleSelector extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = this._stateForProps(this.props);
	}

	componentWillReceiveProps(newProps) {
		this.setState(this._stateForProps(newProps, this.props));
	}

	_stateForProps = (props, oldProps) => {
		// console.log(this.props.relay)

		const existingIds = props.value.map(v => v.id);
		return {
			value: props.value,
			articles: props.viewer.articlesForSelector.articles.filter(t => existingIds.indexOf(t.id) === -1),
			searchText: '',
		};
	};

	removeArticle = (id, index) => {
		const { onRemove, onChange } = this.props;
		if (onRemove) {
			onRemove(index);
		}
		if (onChange) {
			onChange(this.state.value.filter(v => v.id !== id));
		}
	};

	_onNewArticle = (text, index) => {
		let article = null;
		if (index === -1) {
			// это enter в поле
			if (this.state.articles.length > 0) {
				article = this.state.articles.length[0];
			}
		} else {
			const suggestions = this.state.articles.slice(0);
			article = suggestions.splice(index, 1);
		}

		if (article && this.props.onAdd) {
			this.props.onAdd(article);
		}

		if (article && this.props.onChange) {
			const res = [].concat(this.state.value, article);
			this.props.onChange(res);
		}
	};

	debounce = (func, delay) => {
		let inDebounce;
		return function() {
			const context = this;
			const args = arguments;
			clearTimeout(inDebounce);
			return (inDebounce = setTimeout(function() {
				return func.apply(context, args);
			}, delay));
		};
	};

	onUpdateInput = s => {
		this.setState({ searchText: s });

		this.debounce(search => {
			const refetchVars = fragmentVars => ({ search });
			console.log(`searching for: ${search}`);
			this.props.relay.refetch(refetchVars, null);
		}, 300)(s);
	};

	render() {
		return (
			<div style={{ width: '100%' }}>
				<AutoComplete
					placeholder={this.props.placeholder}
					// hintText={this.props.hint ? this.props.hint : 'Тема'}
					floatingLabelText={this.props.hint ? this.props.hint : 'Тема'}
					floatingLabelFixed={this.props.floatingLabelFixed}
					openOnFocus={true}
					fullWidth={true}
					dataSourceConfig={{ text: 'title', value: 'id' }}
					dataSource={this.state.articles}
					searchText={this.state.searchText}
					onUpdateInput={this.onUpdateInput.bind(this)}
					onNewRequest={this._onNewArticle.bind(this)}
					menuStyle={{ maxHeight: '30vh' }}
					filter={AutoComplete.caseInsensitiveFilter}
				/>
				<List>
					{this.state.value.map((t, index) => (
						<ListItem
							innerDivStyle={{
								paddingTop: 5,
								paddingLeft: 0,
								paddingBottom: 10,
								paddingRight: 25,
							}}
							hoverColor="transparent"
							key={t.id}
							primaryText={this.props.itemProvider ? this.props.itemProvider(t, index) : t.title}
							rightIconButton={
								<IconButton
									style={{
										padding: 0,
										width: 22,
										height: 22,
									}}
									onClick={() => this.removeArticle(t.id, index)}
								>
									<ClearIcon color={colors.default} hoverColor={colors.linkHover} />
								</IconButton>
							}
						/>
					))}
				</List>
			</div>
		);
	}
}

export default createRefetchContainer(
    ArticleSelector,
    graphql`
        fragment ArticleSelector_viewer on Viewer @argumentDefinitions(search: {type: String}) {
            articlesForSelector: articlesPaginate(page: 1, pageSize: 5, plainSearch: $search, hidden: false) {
                articles {
                    id,
                    title
                }
            }
        }
    `,
    graphql`
        query ArticleSelector_Refetch_Query ( $search: String ) {
            viewer {
                ...ArticleSelector_viewer @arguments (search: $search)
            }
        }
    `
)



// WEBPACK FOOTER //
// src/components/articles/ArticleSelector.js